(function () {
  const initSection = (section) => {
    if (!section || !section.classList.contains("shared-access-showcase-section")) {
      return;
    }

    const showcase = section.querySelector("shared-access-showcase");
    const desktopTriggers = showcase?.querySelectorAll(
      ".shared-access-showcase__features--desktop [data-showcase-trigger]"
    );
    const mobileTriggers = showcase?.querySelectorAll(
      ".shared-access-showcase__mobile-content [data-showcase-trigger]"
    );
    const triggers = showcase?.querySelectorAll("[data-showcase-trigger]");
    const mediaItems = showcase?.querySelectorAll(".shared-access-showcase__media-item");
    const mediaWrapper = showcase?.querySelector(".shared-access-showcase__media");
    const mediaSlider = showcase?.querySelector(".swiper--shared-access-showcase-media");
    const mobileContent = showcase?.querySelector(".swiper--shared-access-showcase");
    const mobilePagination = showcase?.querySelector(
      ".shared-access-showcase__pagination .swiper-pagination"
    );

    if (!showcase || !triggers?.length || !mediaItems?.length) return;

    const updateMediaRatio = (activeItem) => {
      if (!mediaWrapper || mediaWrapper.dataset.adaptRatio !== "true") return;

      const ratio = activeItem?.dataset.mediaRatio;
      if (!ratio) return;

      mediaWrapper.style.setProperty("--shared-access-media-ratio", ratio);
    };

    const setActive = (targetId) => {
      let activeMediaItem = null;

      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.target === targetId;
        trigger.classList.toggle("is-active", isActive);
        trigger.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      mediaItems.forEach((item) => {
        const isActive = item.id === targetId;
        item.classList.toggle("is-active", isActive);

        if (isActive) activeMediaItem = item;
      });

      updateMediaRatio(activeMediaItem);
    };

    desktopTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        setActive(trigger.dataset.target);
      });

      trigger.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;

        event.preventDefault();
        setActive(trigger.dataset.target);
      });

      trigger.addEventListener("mouseenter", () => {
        if (window.innerWidth < 990) return;
        setActive(trigger.dataset.target);
      });
    });

    mobileTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        setActive(trigger.dataset.target);
      });

      trigger.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;

        event.preventDefault();
        setActive(trigger.dataset.target);
      });
    });

    if (mobileContent && mobileContent.dataset.initialized !== "true") {
      mobileContent.dataset.initialized = "true";

      const contentSwiper = new Swiper(mobileContent, {
        enabled: true,
        loop: false,
        speed: 800,
        spaceBetween: 8,
        autoHeight: false,
        pagination: mobilePagination
          ? {
              el: mobilePagination,
              type: "bullets",
              clickable: true
            }
          : false,
        breakpoints: {
          990: {
            enabled: false
          }
        },
        on: {
          slideChange: function () {
            const activeTrigger = mobileTriggers[this.activeIndex];
            if (!activeTrigger) return;

            setActive(activeTrigger.dataset.target);
          }
        }
      });

      if (mediaSlider) {
        const mediaSwiper = new Swiper(mediaSlider, {
          loop: false,
          speed: 800,
          spaceBetween: 8,
          breakpoints: {
            990: {
              enabled: false
            }
          }
        });

        contentSwiper.controller.control = mediaSwiper;
        mediaSwiper.controller.control = contentSwiper;
      }
    }
  };

  initSection(document.currentScript?.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
